import React from "react"
import style from "../components/leesItemMobile.module.scss"
import linkIcon from "../assets/svg/icon_extLink.svg"

export default function LeesItemMobile({ links, info }) {
  return (
    <div className={style.wrapper}>
      <div className={style.beeld}>
        {links.map(item => {
          return (
            <a href={item.link} target="_blank" rel="noreferrer">
              {item.naam}
              <img width="15px" src={linkIcon} alt="link"></img>
            </a>
          )
        })}
      </div>
      <div className={style.info}>
        <h3>Lucy in de lucht</h3>
        {info.link && (
          <a href={info.link} target="_blank" rel="noreferrer">
            Video &#10132;
          </a>
        )}

        <h4>WEEF BLOG</h4>
      </div>
    </div>
  )
}
